import NumberOfCompanies from './component/numberOfCompanies'
import RatioComparison from './component/ratioComparison'
import Size from './component/size'
import { mapViewBy } from './constant'

const componentMap = {
  sizeChecked: Size,
  nocChecked: NumberOfCompanies,
  ratioChecked: RatioComparison,
}

const radioMap = {
  sizeRadio: Size,
  nocRadio: NumberOfCompanies,
  ratioRadio: RatioComparison,
}

const SectorPerformanceExport = ({ settingDynamic }) => {
  const { viewBy, childrenRadio, childrenChecked } = settingDynamic

  if (viewBy === mapViewBy.chart.value) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {childrenChecked.map((key) => {
          const Component = componentMap[key]
          return Component ? (
            <div key={key} style={{ marginBottom: 8 }}>
              <Component
                viewBy={viewBy}
                isDynamicReport
                settingDynamic={settingDynamic}
              />
            </div>
          ) : null
        })}
      </div>
    )
  }

  const RadioComponent = radioMap[childrenRadio]
  return RadioComponent ? (
    <RadioComponent
      viewBy={viewBy}
      isDynamicReport
      settingDynamic={settingDynamic}
    />
  ) : (
    <div />
  )
}

export default SectorPerformanceExport
